import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import AddIcon from '@material-ui/icons/AddBox';
import EventIcon from '@material-ui/icons/Event';
import LocationIcon from '@material-ui/icons/LocationOn';
import TimeIcon from '@material-ui/icons/AccessTime';

import { getGoogleCalendarLink } from '@utils/calendarLinks';

import Icon from '@components/Icon/Icon';

import './EventCard.scss';

const EventCard = ({
  date,
  location,
  name,
  showTime,
}) => (
  <div className="event-card">
    {name && (
      <div className="event-card__title">
        {name}
      </div>
    )}
    {date && (
      <div className="event-card__details">
        <Icon className="event-card__details-icon">
          <EventIcon />
        </Icon>
        <div>
          {moment(date).format('L')}
        </div>
      </div>
    )}
    {date && showTime && (
      <div className="event-card__details">
        <Icon className="event-card__details-icon">
          <TimeIcon />
        </Icon>
        <div>
          {moment(date).format('LT')}
        </div>
      </div>
    )}
    {location && (
      <div className="event-card__details">
        <Icon className="event-card__details-icon">
          <LocationIcon />
        </Icon>
        <div>
          {location}
        </div>
      </div>
    )}
    {moment(date).isAfter() && (
      <a
        href={getGoogleCalendarLink({
          location,
          date,
          title: name,
        })}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="event-card__add-to-calendar">
          <Icon className="event-card__icon-wrapper">
            <AddIcon />
          </Icon>
          <div>
            Add to calendar
          </div>
        </div>
      </a>
    )}
    {moment(date).isBefore() && (
      <div className="event-card__expired">
        Expired
      </div>
    )}
  </div>
);

EventCard.propTypes = {
  date: PropTypes.string,
  location: PropTypes.string,
  name: PropTypes.string,
  showTime: PropTypes.bool,
};

EventCard.defaultProps = {
  date: '',
  location: '',
  name: '',
  showTime: true,
};

export default EventCard;



// WEBPACK FOOTER //
// ./src/routes/Case/Details/components/EventCard/EventCard.js